import React from 'react';

import { changeDateFormat } from '@utils/Util';

const EtdUpdateTimeline = ({ timelineData }) => {
	return (
		<div className="design-timeline-container">
			<ul className="design-timeline design-timeline-centered">
				{timelineData?.map((item) => (
					<li className="design-timeline-item status purple-1">
						<div className="design-timeline-marker"></div>
						<div className="design-timeline-content">
							<p className="regular-14">{item?.changedByResponse?.name}</p>
							<span className="regular-12">
								{changeDateFormat(item?.newValue, 'YYYY-MM-DD', 'Do MMM, YYYY')}
							</span>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
};

export default EtdUpdateTimeline;
